/* eslint-disable jsx-a11y/iframe-has-title */
import TitleHeader from "../../components/Common/TitleHeader";
import {
  ColumnContainer,
  MainContainer,
  MainText,
  ResContainer,
  SubText,
} from "../../helpers/StyledComponents";
import { Divider } from "antd";
import BookCard from "../../components/Book/BookCard";

const HotshotsBook = () => {
  return (
    <MainContainer>
      <ColumnContainer alignItems="center">
        <TitleHeader en="HOTSHOTS SERIES" th="ชุดฮ็อตช็อตส์" center />
        <SubText align="center">
          วางตลาด ตั้งแต่ ตุลาคม 2012 หนังสือเฝ้าเดี่ยวสำหรับเด็ก อายุ 9-12
          ปีขึ้นไป (Bilingual/อังกฤษและไทย)
        </SubText>
        <Divider />

        <ResContainer gap="20">
          <BookCard
            title="Mini-Stars of the Bible Book 1 / ดาราตัวน้อยในพระคัมภีร์ เล่ม 1"
            subtitle="104 หน้า ราคาเล่มละ 65 บาท"
            desc={
              <SubText fs="14">
                เด็กๆ จะพบกับพี่เจ๊ฟซึ่งเป็นหัวหน้าฮ็อตช็อตส์
                ช่วยหาคำตอบในคำถามต่างๆ ที่อยากรู้ เช่น{" "}
                <MainText fs="14">
                  "เด็กๆ เป็นคนสำคัญ" "ทุกคนแตกต่างกัน " "ครอบครัวนั้นสำคัญ"
                </MainText>
                นอกจากนี้ ยังมีเรื่องจริงจากประวัติศาสตร์โลก ปริศนา
                กิจกรรมฝึกทักษะ จุดประกายอธิษฐาน เด็กๆ
                จะได้อ่านทั้งพระคัมภีร์เดิมและพระคัมภีร์ใหม่มากมาย
                และทั้งยังเรียนรู้ที่จะอธิษฐานถึงสิ่งต่างๆ
                ที่สำคัญต่อชีวิตของเขาด้วย
              </SubText>
            }
            img="/webImg/Star1r20New.jpeg"
            link="https://drive.google.com/file/d/1qSY9ePrdxzCQFEVwKx90KXhvelgjOquh/view?usp=sharing"
          />
          <BookCard
            title="Mini-Stars of the Bible Book 2 / ดาราตัวน้อยในพระคัมภีร์ เล่ม 2"
            subtitle="104 หน้า ราคาเล่มละ 65 บาท"
            desc={
              <SubText fs="14">
                เด็กๆ จะพบกับพี่เจ๊ฟซึ่งเป็ยหัวหน้าฮ็อตช็อตส์
                ช่วยหาคำตอบในคำถามต่างๆ ที่อยากรู้ เช่น
                <MainText fs="14">
                  "เธอคิดว่าเธอเป็นใคร?" "เลิกเศร้าใจได้แล้ว " "มองไม่เห็น
                  แต่มีจริง"
                </MainText>
                นอกจากนี้ ยังมีเรื่องจริงจากประวัติศาสตร์โลก ปริศนา
                กิจกรรมฝึกทักษะ จุดประกายอธิษฐาน เด็กๆ
                จะได้อ่านทั้งพระคัมภีร์เดิมและพระคัมภีร์ใหม่มากมาย
                และทั้งยังเรียนรู้ที่จะอธิษฐานถึงสิ่งต่างๆ
                ที่สำคัญต่อชีวิตของเขาด้วย
              </SubText>
            }
            img="/webImg/Star2r20New.jpeg"
            link="https://drive.google.com/file/d/1qSY9ePrdxzCQFEVwKx90KXhvelgjOquh/view?usp=sharing"
          />
          <BookCard
            title="What I Wanna Know Book 1 / ฉันอยากจะรู้ว่า เล่ม 1"
            subtitle="80 หน้า ราคาเล่มละ 60 บาท"
            desc={
              <SubText fs="14">
                เด็กๆ จะพบกับพี่เจ๊ฟซึ่งเป็นหัวหน้าฮ็อตช็อตส์
                ช่วยหาคำตอบในคำถามต่างๆ ที่อยากรู้ เช่น
                <MainText fs="14">
                  "นรกอยู่ที่ไหน?" "สวรรค์เป็นอย่างไร? "
                  "คนป่วยเป็นคนที่ไม่ดีเหรอ?"
                </MainText>
                นอกจากนี้ ยังมีเรื่องจริงจากประวัติศาสตร์โลก ปริศนา
                กิจกรรมฝึกทักษะ จุดประกายอธิษฐาน เด็กๆ
                จะได้อ่านทั้งพระคัมภีร์เดิมและพระคัมภีร์ใหม่มากมาย
                และทั้งยังเรียนรู้ที่จะอธิษฐานถึงสิ่งต่างๆ
                ที่สำคัญต่อชีวิตของเขาด้วย
              </SubText>
            }
            img="/webImg/hotshot1New.jpeg"
            link="https://drive.google.com/file/d/1qSY9ePrdxzCQFEVwKx90KXhvelgjOquh/view?usp=sharing"
          />
          <BookCard
            title="What I Wanna Know Book 2 / ฉันอยากจะรู้ว่า เล่ม 2"
            subtitle="96 หน้าราคาเล่มละ 60 บาท"
            desc={
              <SubText fs="14">
                เด็กๆ จะพบกับพี่เจ๊ฟซึ่งเป็นหัวหน้าฮ็อตช็อตส์
                ช่วยหาคำตอบในคำถามต่างๆ ที่อยากรู้ เช่น
                <MainText fs="14">
                  "ใครเป็นคนสร้างพระเจ้า?" "พระเจ้าเป็นผู้ชายหรือผู้หญิง?"
                  "พระเจ้าสร้างโลกนี้ขึ้นมาเพื่ออะไร?"
                </MainText>
                นอกจากนี้ ยังมีเรื่องจริงจากประวัติศาสตร์โลก ปริศนา
                กิจกรรมฝึกทักษะ จุดประกายอธิษฐาน เด็กๆ
                จะได้อ่านทั้งพระคัมภีร์เดิมและพระคัมภีร์ใหม่มากมาย
                และทั้งยังเรียนรู้ที่จะอธิษฐานถึงสิ่งต่างๆ
                ที่สำคัญต่อชีวิตของเขาด้วย
              </SubText>
            }
            img="/webImg/hotshot2New.jpeg"
            link="https://drive.google.com/file/d/1qSY9ePrdxzCQFEVwKx90KXhvelgjOquh/view?usp=sharing"
          />
        </ResContainer>
        <Divider />
        <TitleHeader
          en="HOTSHOTS SERIES"
          th="สั่งซื้อชุดฮ็อตช็อตส์ได้ที่นี่"
          center
        />
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSd1Gl8T_RYAzNSwTtK5XXBJbbJz7CcySSE2tYbjY2Hrv1tG3g/viewform?embedded=true"
          width="100%"
          height="1200"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>

        {/* <Form
          size={"default"}
          style={{ width: `${isMobile ? "300px" : "500px"}` }}
        >
          <Form.Item label={<div>ชื่อ - นามสกุล</div>}>
            <Input onChange={(e) => onChangeDetails("name", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>เบอร์โทรศัพท์</div>}>
            <Input onChange={(e) => onChangeDetails("phone", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>อีเมล์</div>}>
            <Input onChange={(e) => onChangeDetails("email", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>ที่อยู่สำหรับจัดส่ง</div>}>
            <Input.TextArea />
          </Form.Item>
          <Form.List
            name="names"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names) {
                    return Promise.reject(
                      new Error("กรุณาเลือกหนังสือที่ท่านต้องการสั่งซื้อ")
                    );
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item
                    {...(index === 0
                      ? formItemLayout
                      : formItemLayoutWithOutLabel)}
                    label={index === 0 ? <div>สั่งซื้อหนังสือ</div> : ""}
                    required={false}
                    key={field.key}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: "กรุณาเลือกหนังสือ หรือลบช่องนี้",
                        },
                      ]}
                      noStyle
                    >
                      <Select
                        onChange={(e) => onChangePrice(e)}
                        style={{
                          width: fields.length > 1 && "90%",
                        }}
                      >
                        {BOOKS.map((i) => (
                          <Select.Option key={i} value={i.label}>
                            <div>{i.label}</div>
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        onClick={() => remove(field.name)}
                        style={{ marginLeft: "5px", color: "red" }}
                      />
                    ) : null}
                  </Form.Item>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    style={{ width: "100%" }}
                  >
                    <div>
                      <PlusOutlined style={{ marginRight: "5px" }} />
                      คลิกเพื่อเพิ่มหนังสือ
                    </div>
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
          <MainText mb="10">
            ราคารวมทั้งหมด: {get(priceTotle, "", "0")} บาท
          </MainText>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form> */}
      </ColumnContainer>
    </MainContainer>
  );
};

export default HotshotsBook;
